import React from "react";
import "./UiInput.css";
import { useState } from "react";
import { useEffect } from "react";
import { ICON } from "../../../assets";
import UiIcon from "../UiIcon";

const UI_INPUT_TYPE = {
  TEXT: "text",
  PASSWORD: "password",
  EMAIL: "email",
  NUMBER: "number",
};

function UiInput({
  type = UI_INPUT_TYPE.TEXT,
  placeholder = "",
  value,
  onChange = () => {},
  style,
  className,
  name,
  errorMessage,
  readOnly = false,
  icon = ICON.errorIcon,
  throwError = false,
  required = false,
  ...props
}) {
  if (Object.values(UI_INPUT_TYPE).includes(type) === false) {
    type = UI_INPUT_TYPE.TEXT;
  }

  const [error, setError] = useState(null);
  const [waitforclick, setWaitforclick] = useState(false);
  const [inputValue, setInputValue] = useState(value);

  const throwErrorData = () => {
    if (type === UI_INPUT_TYPE.EMAIL) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (inputValue && !emailRegex.test(inputValue)) {
        setError("S'il vous plaît, mettez une adresse email valide");
        return false;
      }
    }
    if (type === UI_INPUT_TYPE.NUMBER) {
      if (inputValue && isNaN(inputValue)) {
        setError("Veuillez saisir un numéro valide");
        return false;
      }
    }
    return true;
  };
  useEffect(() => {
    if (throwError && required) {
      setError(errorMessage || "Ce champ est obligatoire");
    }
  }, [throwError]);

  useEffect(() => {
    if (!inputValue && errorMessage && waitforclick && !readOnly) {
      setError(errorMessage);
    } else {
      setError(null);
    }
    if (!readOnly) throwErrorData() && setError(null);
    if (throwError && !inputValue) {
      setError(errorMessage || "Ce champ est obligatoire");
    }
  }, [inputValue, waitforclick, errorMessage, value]);

  const handleChange = (e) => {
    e.preventDefault();
    e.stopPropagation();
    let { name, value } = e.target;
    if (type === UI_INPUT_TYPE.NUMBER) {
      value = value ? Number(value) : null;
    }
    onChange({ name, value });
    setInputValue(value);
  };

  const handleBlur = () => {
    setWaitforclick(true);
    // if (!inputValue && errorMessage && !readOnly) {
    //   setError(errorMessage);
    // } else {
    setError(null);
    // }
  };

  return (
    <React.Fragment>
      <input
        onClick={() => setWaitforclick(true)}
        type={type}
        placeholder={placeholder}
        value={inputValue}
        onChange={handleChange}
        onBlur={handleBlur}
        style={style}
        className={`ui-input ${className || ""} ${error ? "error" : ""} ${
          readOnly ? "read-only" : ""
        }`}
        name={name}
        readOnly={readOnly}
        {...props}
      />
      {error && (
        <div className="error-message">
          {icon && <UiIcon icon={icon} alt="error icon" size="md" />}
          <span>{error}</span>
        </div>
      )}
    </React.Fragment>
  );
}

export default UiInput;
export { UI_INPUT_TYPE };
